(function () {
  'use strict';

  var config = window.athBuyMoreConfig || {};
  var regularRates = config.regularRates || [0, 5, 10, 15, 20];
  var deadline = Date.parse(config.endsAt);

  function tier(count) {
    return Math.max(1, Math.min(5, Math.floor(Number(count) || 0)));
  }

  function isActive() {
    return config.enabled === true && isFinite(deadline) && Date.now() < deadline;
  }

  function regularPercent(count) {
    return Number(regularRates[tier(count) - 1]) || 0;
  }

  function previewInput(count, cents) {
    var product = window.athPromotionProduct;
    if (!product && document.querySelector) {
      var button = document.querySelector('.landing-page-variant-add[data-promotion-collections]');
      if (button) {
        try { product = {unitPrice:Number(button.getAttribute('data-variant-price')),collectionIds:JSON.parse(button.getAttribute('data-promotion-collections'))}; } catch (e) { /* Unknown membership cannot qualify for a restricted offer. */ }
      }
    }
    var subtotal = typeof cents === 'number' ? cents : (product ? product.unitPrice * count : 0);
    var result = {quantity:count,subtotal:subtotal,currency:product && product.currency || 'USD'};
    if (product) result.items = [{quantity:count,subtotal:subtotal,collectionIds:product.collectionIds}];
    return result;
  }
  function decision(count, input) {
    var policy = window.athPromotionPolicy;
    if (!policy || !policy.snapshot().intent) return null;
    var context=Object.assign({},input || previewInput(count));
    var state=window.couponState || {};
    context.blocked=!!(context.blocked || state.b2g1Selected || state.promotionSelectionUnknown || state.manualOverride);
    var selected=state.promotionCurrentCode || (state.isManual && state.currentCode);
    if (selected && !/^(BLACKFRIDAYDEALS|BUYMORE[2-5](?:EBF)?)$/i.test(selected)) context.manualCode=selected;
    if (!policy.enabled) return {mode:'suspended',code:state.currentCode || null,percentage:null,savings:null,nextBetterQuantity:null,nextBetterPercentage:null};
    var result=policy.resolve(context);
    if (state.promotionFailedTarget && result.code === state.promotionFailedTarget) {
      result=policy.resolve(Object.assign({},context,{currentCode:state.currentCode,confirmedOnly:true}));
    }
    return result;
  }
  function heading(original) {
    return decision(1) ? 'BLACK FRIDAY SAVINGS' : isActive() ? 'EXTRA +5% BONUS SAVINGS - THIS WEEK ONLY' : original;
  }
  function percent(count, input) {
    var d = decision(count,input);
    if (d && d.mode !== 'standard') return d.percentage || 0;
    return regularPercent(count) + (tier(count) > 1 && isActive() ? Number(config.bonus) || 0 : 0);
  }

  function coupon(count, input) {
    var d = decision(count,input);
    if (d && d.mode !== 'standard') return d.code;
    if (Number(count) < 2) return null;
    return 'BUYMORE' + tier(count) + (isActive() ? config.couponSuffix : '');
  }

  function total(cents, count, input) {
    var context = input || previewInput(count,cents);
    var d = decision(count,context);
    if (d && d.mode !== 'standard') return d.savings === null ? cents : Math.round(cents-d.savings);
    return Math.round(cents * (100 - percent(count)) / 100);
  }

  function badge(count, regularLabel, input) {
    var d = decision(count,input);
    if (d && d.mode !== 'standard') return d.percentage === null ? '' : '<strong class="buy-more-discount__bonus">'+d.percentage+'% OFF</strong>';
    if (count < 2) return '';
    if (!isActive()) return regularLabel || (regularPercent(count) + '% OFF');
    return '<s class="buy-more-discount__original">' + regularPercent(count) + '% OFF</s>' +
      '<strong class="buy-more-discount__bonus">' + percent(count) + '% OFF</strong>';
  }

  function message(count, totalPrice, input) {
    var d = decision(count,input);
    if (d && d.mode !== 'standard') {
      if (!count) return '';
      if (d.percentage === null && input && input.currentCode && input.currentCode.toUpperCase() === d.code) return 'YOUR OFFER IS APPLIED!';
      if (d.percentage === null || (input && Object.prototype.hasOwnProperty.call(input,'currentCode') && (input.currentCode || '').toUpperCase() !== d.code)) return 'APPLYING YOUR OFFER...';
      var text = '<strong>'+d.percentage+'% OFF APPLIED!</strong>';
      if (d.nextBetterQuantity) return text+' ADD '+(d.nextBetterQuantity-count)+' MORE TO GET <strong>'+d.nextBetterPercentage+'% OFF!</strong>';
      return text+(totalPrice >= 9900 ? ' YOUR ORDER SHIPS FREE, LOAD UP!' : '');
    }
    if (!count) return '';
    var applied = count > 1 ? '<strong>' + percent(count) + '% OFF APPLIED!</strong>' : '';
    if (count >= 5) {
      return applied + (totalPrice >= 9900 ? ' YOUR ORDER SHIPS FREE, LOAD UP!' : '');
    }
    return (applied ? applied + ' ' : '') + 'ADD 1 MORE TO GET <strong>' +
      percent(count + 1) + '% OFF!</strong>';
  }

  var wasActive = isActive();
  function refresh() {
    var active = isActive();
    var offer = decision(1);
    if (document.documentElement) document.documentElement.classList.toggle('ad-promotion-pending', !!offer && offer.percentage === null);
    document.querySelectorAll('[data-ebf-ends-at]').forEach(function (banner) {
      banner.hidden = !active;
      if (!active) return;
      var seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      var days = Math.floor(seconds / 86400);
      var hours = Math.floor(seconds % 86400 / 3600);
      var minutes = Math.floor(seconds % 3600 / 60);
      function pad(value) { return value < 10 ? '0' + value : '' + value; }
      var clock = banner.querySelector('[data-ebf-clock]');
      if (clock) clock.textContent = 'Ends in ' + days + 'd ' + pad(hours) + 'h ' +
        pad(minutes) + 'm ' + pad(seconds % 60) + 's';
    });
    document.querySelectorAll('[data-buy-more-title]').forEach(function (label) {
      label.textContent = active ? 'EBF BONUS!' : 'Level Up!';
    });
    document.querySelectorAll('[data-buy-more-percent]').forEach(function (label) {
      label.textContent = percent(Number(label.getAttribute('data-buy-more-percent'))) + '% Off';
    });
    document.querySelectorAll('[data-buy-more-bonus-heading]').forEach(function (heading) {
      heading.hidden = !active && !offer;
      heading.textContent = window.athBuyMore.heading('');
    });
    document.querySelectorAll('[data-bundle-tier]').forEach(function (card) {
      var count = Number(card.getAttribute('data-bundle-tier'));
      var callout = card.querySelector('.discount-tier__callout');
      var regularLabel = count === 5 ? 'FREE BAG' : regularPercent(count) + '% OFF';
      var context = window.athPromotionBundlePreview && window.athPromotionBundlePreview.quantity === count ? window.athPromotionBundlePreview : null;
      var html = badge(count, regularLabel, context);
      if (callout && callout.innerHTML !== html) callout.innerHTML = html;
      var perStick = card.querySelector('.discount-tier__per-stick');
      var referencePrice = Number(card.getAttribute('data-reference-price'));
      if (perStick && referencePrice) {
        var text = '$' + (total(context ? context.subtotal : referencePrice * count, count, context) / (count * 30 * 100)).toFixed(2) + ' / stick';
        if (perStick.textContent !== text) perStick.textContent = text;
      }
      if (card.parentNode) card.parentNode.classList.toggle('tiered-discount-info--ebf', active);
    });
    if (wasActive !== active) {
      wasActive = active;
      document.dispatchEvent(new CustomEvent('ath:buy-more-change'));
    }
  }

  window.athBuyMore = { isActive: isActive, regularPercent: regularPercent, percent: percent, coupon: coupon,
    total: total, badge: badge, message: message, refresh: refresh, heading: heading, decision: decision, previewInput: previewInput };
  document.addEventListener('ath:promotion-change', function () {
    refresh();
    document.dispatchEvent(new CustomEvent('ath:buy-more-change'));
  });

  function init() {
    refresh();
    setInterval(refresh, 1000);
    document.addEventListener('visibilitychange', refresh);
    document.addEventListener('shopify:section:load', refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
